import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    //lng: "en",
    //supportedLngs: ["en", "es", "zh", "zh-Hant"],
    //nonExplicitSupportedLngs: true,
    fallbackLng: "en",
    /*
    fallbackLng: { 
      'zh': ['en'],
      'default': ['en']
    },
    */
    debug: false,
    ns: "common",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    detection: {
      order: [
        "querystring",
        "cookie",
        "localStorage",
        "sessionStorage",
        "htmlTag",
        "path",
        "subdomain",
      ],
    },
  })
  .then(function (t) {
    function getCassieLanguageCode(languageCode) {
      switch (languageCode) {
        case "en": {
          return "";
        }
        case "es": {
          return "es-mx";
        }
        case "nl": {
          return "nl";
        }
        case "fr": {
          return "fr";
        }
        case "ru": {
          return "ru";
        }
        case "zh-hant-tw": {
          return "TW";
        }
        case "zh-hant-hk": {
          return "HK";
        }
        default:
          return "";
      }
    }
    if (window.location.hostname !== "localhost") {
      const cookieWidgetLang = getCassieLanguageCode(
        i18n.resolvedLanguage.toLowerCase()
      );
      window.GetCookieWidget(
        "17",
        "F3933AD2-9BB3-471C-AE63-4B1BDC6670E4",
        "B0E1099E-71B0-41EB-A9A0-978C94048414",
        "cookie-widget",
        "1",
        cookieWidgetLang,
        "",
        ""
      );
    }
  });

export default i18n;
